import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en';

// Set the key-value pairs for the different languages you want to support.
i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  lng: 'en',
  resources: { en: { translation: en } },
});

export default i18n;
